/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

export enum Schritt {
    firmendaten,
    finanzeinstellungen,
    branding,
    zahlungsmethode,
    stripe,
}

export const SCHRITTE: Schritt[] = Object.keys(Schritt)
    .map(key => Number(key))
    .filter(key => !isNaN(key));

type Schnelleinstieg = {
    schnelleinstiegId: string;
    geaendert: string;
    naechsterSchritt?: Schritt;
    istVollstaendigDurchgefuehrt: boolean;
};

export default Schnelleinstieg;